import types from './types'

export default {
  [types.mutations.setDataLoaded]: (state, { tab, val }) => {
    switch (tab) {
      case 'calendar':
        state.calendar.isDataLoaded = val
        break
      case 'crops':
        state.crops.isDataLoaded = val
        break
      case 'wishlist':
        state.wishlist.isDataLoaded = val
        break
    }
  },
  [types.mutations.setIsLoadingMoreDataPast]: (state, val) => {
    state.calendar.isLoadingMoreDataPast = val
  },
  [types.mutations.setIsLoadingMoreDataFuture]: (state, val) => {
    state.calendar.isLoadingMoreDataFuture = val
  },
  [types.mutations.setCalendarCollapsed]: (state, calendarCollapsed) => {
    state.calendar.calendarCollapsed = calendarCollapsed
  },
  [types.mutations.setSelectedDate]: (state, selectedDate) => {
    state.calendar.selectedDate = selectedDate
  }
}
